import { render, staticRenderFns } from "./lecturerCategory.vue?vue&type=template&id=74d5a9d9&scoped=true"
import script from "./lecturerCategory.vue?vue&type=script&lang=js"
export * from "./lecturerCategory.vue?vue&type=script&lang=js"
import style0 from "./lecturerCategory.vue?vue&type=style&index=0&id=74d5a9d9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74d5a9d9",
  null
  
)

export default component.exports